import {reactive} from 'vue'
import {previewImageUrl} from './adminImage'

export function productImageSources(cover:string,attachments:unknown[],baseUrl:string):string[]{
  const sources:string[]=[]
  function add(value:unknown){
    if(typeof value!=='string' || !value.trim())return
    let source=value.trim()
    if(/^[a-z][a-z\d+.-]*:/i.test(source) && !/^(https?:|blob:|data:image\/)/i.test(source))return
    if(!/^(https?:|blob:|data:|\/\/)/i.test(source) && baseUrl)source=baseUrl.replace(/\/$/,'')+'/'+source.replace(/^\//,'')
    source=previewImageUrl(source)
    if(!sources.includes(source))sources.push(source)
  }
  for(const entry of attachments || []){
    if(!entry || typeof entry!=='object')continue
    const file=entry as Record<string,unknown>
    if(file.fileType!==undefined && file.fileType!==null && Number(file.fileType)!==0)continue
    add(file.originalUrl || file.imagePath || file.imagepath || file.url)
  }
  const original=previewImageUrl(cover || '')
  if(original && !sources.includes(original))sources.unshift(original)
  return sources
}

export function createProductImageGallery(load:(id:number)=>Promise<unknown[]>,baseUrl:()=>string){
  const state=reactive({visible:false,sources:[] as string[],index:0,busy:false,error:''})
  let generation=0
  function close(){generation++;state.visible=false;state.sources=[];state.index=0;state.busy=false;state.error=''}
  async function open(cover:string,id?:number|string,attachments?:unknown[]){
    close()
    if(!cover)return
    const request=generation
    state.sources=productImageSources(cover,attachments || [],baseUrl())
    state.index=Math.max(0,state.sources.indexOf(previewImageUrl(cover)))
    state.visible=true
    if(attachments || !Number.isSafeInteger(Number(id)) || Number(id)<=0)return
    state.busy=true
    try{
      const files=await load(Number(id))
      if(request!==generation || !state.visible)return
      const current=state.sources[state.index]
      state.sources=productImageSources(cover,files,baseUrl())
      state.index=Math.max(0,state.sources.indexOf(current))
    }catch(error){
      if(request===generation && state.visible)state.error='商品图片读取失败，请关闭后重新打开重试'
    }finally{if(request===generation)state.busy=false}
  }
  function move(direction:number){
    const next=state.index+direction
    if(state.visible && !state.busy && next>=0 && next<state.sources.length)state.index=next
  }
  return {state,open,close,move}
}
